import React from "react";
import Slider, { Settings } from "react-slick";
import BannerModel from "../model/BannerModel";

const settings: Settings = {
  speed: 300,
  infinite: false,
  variableWidth: false,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 5000,
  autoplay: true,
  // rows: 0,
};

type BuscaProdutosProps = {
  banners: BannerModel[];
};

class BannersHome extends React.Component<BuscaProdutosProps, any> {
  render(): any {
    const { banners } = this.props;

    return (
      <Slider {...settings} className="banners">
        {banners &&
          banners.map((b: BannerModel) => (
            <div className="item" key={b.bannerId}>
              {b.link && b.link.length > 0 &&
              <a href={b.link} target="_blank" rel="noopener noreferrer">
                <img src={b.imagem} alt={b.titulo} title={b.titulo} />
              </a>
              }
              {(!b.link || b.link.length === 0) &&
              <img src={b.imagem} alt={b.titulo} title={b.titulo} />
              }
            </div>
          ))}
      </Slider>
    );
  }
}

export default BannersHome;
